import { ColumnDef } from "@tanstack/react-table"

import type { EditBookType } from "@/types/book"

import { DataTableColumnHeader } from "../../data-table"
import { BooksOperations } from "../operations/books-operations"

export const booksColumns: ColumnDef<EditBookType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div className="text-right md:py-0 md:text-left">{value}</div>
    },
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.name
      return <div className="text-right md:py-0 md:text-left">{value}</div>
    },
  },
  {
    accessorKey: "zone",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Zone"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.zone
      return <div className="text-right md:py-0 md:text-center">{value}</div>
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div className="text-right md:py-0 md:text-left">{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <BooksOperations data={row.original} />
        </div>
      )
    },
  },
]
